// Entry point for picturefill and lazySizes
require('picturefill')
require('lazysizes')
require('lazysizes/plugins/parent-fit/ls.parent-fit')
require('lazysizes/plugins/bgset/ls.bgset')
// Remove the H descriptor in Edge browsers that do not support it
// Taken from lazySizes respimg, which does not run when picturefill is present
// https://github.com/aFarkas/lazysizes/blob/083e12d/plugins/respimg/ls.respimg.js
if (navigator.userAgent.match(/Edge\/(\d+)/)) {
  let regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
  let regHDesc = /\s+\d+h/g
  let img = document.createElement('img')
  let removeHDescriptors = function (source) {
    let srcset = source.getAttribute(window.lazySizesConfig.srcsetAttr)
    if (srcset) {
      if (srcset.match(regDescriptors)) {
        let ratio
        if (RegExp.$2 === 'w') {
          ratio = RegExp.$1 / RegExp.$3
        } else {
          ratio = RegExp.$3 / RegExp.$1
        }
        if (ratio) {
          source.setAttribute('data-aspectratio', ratio)
        }
      }
      source.setAttribute(window.lazySizesConfig.srcsetAttr, srcset.replace(regHDesc, ''))
    }
  }
  let handler = function (e) {
    let picture = e.target.parentNode
    if (picture && picture.nodeName === 'PICTURE') {
      Array.prototype.forEach.call(picture.getElementsByTagName('source'), removeHDescriptors)
    }
    removeHDescriptors(e.target)
  }
  let test = function () {
    // If srcset was properly loaded with a height descriptor, remove the listener
    if (img.currentSrc) {
      document.removeEventListener('lazybeforeunveil', handler)
    }
  }
  document.addEventListener('lazybeforeunveil', handler)
  img.onload = test
  img.onerror = test
  img.srcset = 'data:,a 1w 1h'
  if (img.complete) {
    test()
  }
}



// WEBPACK FOOTER //
// ./src/js/picture.js